var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClubbieLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#082441"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8125 37.3969C42.8115 37.3989 42.811 37.4011 42.811 37.4033V40.006C42.811 41.2451 41.7937 42.2523 40.5342 42.2603H25.7753C24.5238 42.2603 23.5065 41.2531 23.4984 40.006V25.169C23.4984 23.9699 24.4754 23.0027 25.6864 22.9947H40.4938C41.7533 22.9947 42.7706 24.0099 42.7706 25.249C42.7706 26.1432 43.7457 26.6961 44.5131 26.2369L47.8887 24.2172C49.4422 23.2877 50.0107 21.2757 48.8981 19.8475C45.2022 15.1028 39.4514 12.2531 33.2758 12.2666C22.2631 12.2666 13.3416 21.0921 13.3335 31.988C13.3335 42.8919 22.247 51.7253 33.2516 51.7333C38.9684 51.7333 44.3315 49.3166 48.0695 45.2116C49.7116 43.4083 48.9054 40.6698 46.7593 39.5112L42.8319 37.3909C42.8249 37.3871 42.8161 37.3898 42.8125 37.3969Z",
    fill: "#E7BA19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubbieLogo);
export default __webpack_public_path__ + "static/media/clubbie_logo.99359b645895f1796cfc71d2ef866e26.svg";
export { ForwardRef as ReactComponent };